const ESPACES = /[\s ]+/g;

// Recherche de PAV (nomenclature / adresse / commune), partagée par la Coquille.

/** Minuscules, sans accents, espaces réduits. */
export function normaliser(texte) {
    if (texte == null) return '';
    return String(texte)
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(ESPACES, ' ')
        .trim();
}

// Liste normalisée {pav, n, a, c} (nomenclature, adresse, commune) construite une fois par index.
const cacheRecherche = new WeakMap();
function listeRecherche(index) {
    let liste = cacheRecherche.get(index);
    if (!liste) {
        liste = index.pavs.map((pav) => ({pav, n: normaliser(pav.nomenclature), a: normaliser(pav.adresse), c: normaliser(pav.communeLibelle)}));
        cacheRecherche.set(index, liste);
    }
    return liste;
}

/**
 * Suggestions de PAV pour une saisie (nomenclature, adresse, commune ; insensible à la casse et aux accents).
 * Ordre : nomenclature commençant par la saisie, nomenclature contenant la saisie, adresse / commune ; à rang égal,
 * PAV actifs avant retirés puis ordre du snapshot. 2 caractères minimum, `max` suggestions.
 */
export function rechercherPav(index, saisie, max = 8) {
    const q = normaliser(saisie);
    if (!index || q.length < 2) return [];
    const trouves = [];
    listeRecherche(index).forEach(({pav, n, a, c}, ordre) => {
        let rang;
        if (n.startsWith(q)) rang = 0;
        else if (n.includes(q)) rang = 1;
        else if (a.includes(q) || c.includes(q)) rang = 2;
        else return;
        trouves.push({pav, rang: rang * 2 + (pav.statut === 'RETIRÉ' ? 1 : 0), ordre});
    });
    trouves.sort((a, b) => a.rang - b.rang || a.ordre - b.ordre);
    return trouves.slice(0, max).map((t) => t.pav);
}
